import React, { useState } from "react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
} from "./ui/dialog";
import { Flex, Text } from "@radix-ui/themes";
import SignInForm from "../auth/signin/SignInForm";
import { Separator } from "./ui/separator";
import { usePathname, useRouter } from "next/navigation";
import ForgotPassword from "../auth/signin/ForgotPassword";
import { cn } from "@/lib/utils";

interface Props {
  isOpen: boolean | undefined;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onDismiss: any;
  label?: string;
  trigger?: any;
  children?: React.ReactNode | undefined;
}
const LoginPopup = ({
  isOpen,
  setIsOpen,
  onDismiss,
  trigger,
  children,
}: Props) => {
  const currentPath = usePathname();
  const [forgot, setForgot] = useState(false);
  const [loggingIn, setLoggingIn] = useState(false);
  const router = useRouter();
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        setIsOpen(open);
        if (!open) {
          onDismiss();
        }
      }}
    >
      <DialogTrigger onClick={() => setIsOpen(true)} asChild>
        {trigger}
      </DialogTrigger>
      <DialogContent
        className="h-auto max-h-[95vh] overflow-y-auto items-center px-0 gap-0"
        onClick={(e) => e.stopPropagation()}
        onPointerDownCapture={(e) => e.stopPropagation()}
      >
        {!forgot && (
          <div className="w-full flex-col items-center">
            <DialogTitle className="text-bold text-center">
              Sign in or create an account
            </DialogTitle>
            <Separator className="w-full mt-2 mb-0" />
          </div>
        )}
        <DialogDescription className="py-0 !mt-0">
          <Flex direction="column" justify={"start"} align={"center"}>
            <Flex
              className={cn(
                "w-[85%]",
                forgot ? "min-h-[150px]" : "min-h-[450px]"
              )}
            >
              {forgot ? (
                <ForgotPassword
                  setForgot={setForgot}
                  loggingIn={loggingIn}
                  setLoggingIn={setLoggingIn}
                  router={router}
                  redirect={false}
                  onComplete={() => {
                    setIsOpen(false);
                    setForgot(false);
                    setLoggingIn(false);
                    if (onDismiss) onDismiss();
                  }}
                />
              ) : (
                <SignInForm
                  loginPage={false}
                  callbackURL={currentPath}
                  renderBanner={children}
                  overrideClickForgot={() => setForgot(true)}
                  onComplete={() => {
                    setIsOpen(false);
                    if (onDismiss) onDismiss();
                  }}
                />
              )}
            </Flex>
          </Flex>
        </DialogDescription>
      </DialogContent>
    </Dialog>
  );
};

export default LoginPopup;
